import { formatDate } from "../../utils/formatDate";
import { getStatusMeta } from "../../utils/statusMeta";

const TONE_DOT = {
  success: "#0F9A5A",
  warning: "#C2740A",
  danger: "#DC2626",
  info: "#4B36F0",
  neutral: "#8A91AE",
};

/**
 * La orden no expone un historial de auditoría (no hay endpoint ni campo
 * `status_history`): esto arma la línea de tiempo con las únicas fechas
 * de estado que sí existen hoy en el modelo. Ver reporte del Frente D
 * para lo que falta si se quiere un historial completo.
 */
export const OrderStatusTimeline = ({ order }) => {
  if (!order) return null;

  const steps = [
    { label: "Orden creada", date: order.created_at, tone: "neutral" },
    order.payment_paid_approval && { label: "Pago aprobado", date: order.payment_paid_approval, tone: "success" },
    order.delivered_at && { label: "Entregada", date: order.delivered_at, tone: "success" },
    order.cancelled_at && {
      label: "Cancelada",
      date: order.cancelled_at,
      tone: "danger",
      meta: order.cancel_reason,
    },
  ].filter(Boolean);

  if (steps.length === 0) return null;

  const currentMeta = getStatusMeta(order.status);

  return (
    <div className="ui-card">
      <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 16 }}>
        <i className="ri-history-line" style={{ color: "#4B36F0", fontSize: 16 }} />
        <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>Historial de estado</h3>
      </div>
      <div className="ui-timeline">
        <div className="ui-timeline__rail" />
        {steps.map((step, i) => (
          <div className="ui-timeline__item" key={step.label}>
            <span
              className="ui-timeline__dot"
              style={{ background: TONE_DOT[i === steps.length - 1 ? currentMeta.tone : step.tone] }}
            />
            <div className="ui-timeline__label">{step.label}</div>
            <div className="ui-timeline__meta">
              {formatDate(step.date)}
              {step.meta ? ` · ${step.meta}` : ""}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
